export default __webpack_public_path__ + "static/media/image-4.b2cbab27.jpg";